(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vun-respiratory-authority"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-vra-root]').forEach((root) => {
      const tool = root.querySelector('[data-vra-tool]');
      if (!tool || tool.dataset.ready === 'true') return;
      tool.dataset.ready = 'true';

      const panels = Array.from(tool.querySelectorAll('[data-vra-step]'));
      const progress = Array.from(tool.querySelectorAll('[data-vra-go]'));
      const resultWrap = tool.querySelector('[data-vra-result]');
      const answers = {};
      let step = 1;

      const showStep = (nextStep) => {
        step = nextStep;
        resultWrap.hidden = true;
        panels.forEach((panel) => {
          const active = Number(panel.dataset.vraStep) === step;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        progress.forEach((item, index) => {
          const itemStep = index + 1;
          const active = itemStep === step;
          item.classList.toggle('is-active', active);
          item.classList.toggle('is-complete', itemStep < step);
          if (active) {
            item.setAttribute('aria-current', 'step');
          } else {
            item.removeAttribute('aria-current');
          }
        });
      };

      progress.forEach((button) => {
        button.addEventListener('click', () => {
          if (!button.disabled) showStep(Number(button.dataset.vraGo));
        });
      });

      panels.forEach((panel) => {
        const choices = Array.from(panel.querySelectorAll('[data-value]'));
        const next = panel.querySelector('[data-vra-next]');
        const requiredGroups = (panel.dataset.requiredGroups || 'choice').split(',');
        choices.forEach((choice) => {
          choice.addEventListener('click', () => {
            const group = choice.dataset.group || 'choice';
            choices
              .filter((item) => (item.dataset.group || 'choice') === group)
              .forEach((item) => item.classList.remove('is-selected'));
            choice.classList.add('is-selected');
            answers[`step${panel.dataset.vraStep}_${group}`] = choice.dataset.value;
            const complete = requiredGroups.every((requiredGroup) => {
              return Boolean(answers[`step${panel.dataset.vraStep}_${requiredGroup}`]);
            });
            if (next) next.disabled = !complete;
            const nextProgress = progress[Number(panel.dataset.vraStep)];
            if (nextProgress) nextProgress.disabled = !complete;
          });
        });
      });

      tool.querySelectorAll('[data-vra-next]').forEach((button) => {
        button.addEventListener('click', () => {
          if (step < 5) {
            showStep(step + 1);
            return;
          }

          let outcome = 'monitor';
          if (answers.step5_choice === 'emergency') {
            outcome = 'emergency';
          } else if (
            answers.step5_choice === 'concern' ||
            ['fast', 'wheeze'].includes(answers.step2_choice) ||
            ['wet', 'wheeze', 'stuck', 'nasal'].includes(answers.step3_choice) ||
            ['days', 'night', 'exposure', 'worse'].includes(answers.step4_choice) ||
            (
              ['puppy', 'senior'].includes(answers.step1_age) &&
              answers.step2_choice !== 'unsure'
            ) ||
            (
              answers.step1_muzzle === 'flat' &&
              ['honk', 'wheeze', 'fast'].includes(answers.step2_choice)
            )
          ) {
            outcome = 'vet';
          }

          panels.forEach((panel) => { panel.hidden = true; });
          resultWrap.hidden = false;
          resultWrap.querySelectorAll('[data-result]').forEach((card) => {
            card.hidden = card.dataset.result !== outcome;
          });
          progress.forEach((item) => {
            item.classList.remove('is-active');
            item.classList.add('is-complete');
            item.removeAttribute('aria-current');
          });
        });
      });

      tool.querySelectorAll('[data-vra-back]').forEach((button) => {
        button.addEventListener('click', () => showStep(Math.max(1, step - 1)));
      });

      const reset = tool.querySelector('[data-vra-reset]');
      if (reset) {
        reset.addEventListener('click', () => {
          Object.keys(answers).forEach((key) => delete answers[key]);
          tool.querySelectorAll('.is-selected').forEach((item) => item.classList.remove('is-selected'));
          tool.querySelectorAll('[data-vra-next]').forEach((button) => { button.disabled = true; });
          progress.forEach((button, index) => { button.disabled = index > 0; });
          resultWrap.hidden = true;
          showStep(1);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
